import React from 'react'
import { Switch, Route } from 'react-router-dom'
import NotificationsSystem from 'reapop'
import theme from 'reapop-theme-wybo'
import LoadingBar from 'react-redux-loading-bar'

// Routes
import Login from './Login'
// import Adoption from './Adoption'
import Landing from './Landing'
import NotFound from './NotFound'
import ForgetPassword from './ForgetPassword'
import Contact from './Contact'
import Admin from './Admin'
import TermosDeUso from './TermosDeUso'

import PrivateRoute from './../utils/PrivateRoute'
import PublicRoute from './../utils/PublicRoute'

const reload = () => window.location.reload()

const Container = () => (
  <div>
    <LoadingBar style={{ zIndex: 9999, position: 'fixed', backgroundColor: '#00CC69' }} />
    <NotificationsSystem theme={theme} />
    <Switch>
      <PrivateRoute path='/' component={Landing} exact />
      <PublicRoute path='/login' component={Login} exact />
      <PublicRoute path='/forget-password' component={ForgetPassword} exact />
      <PublicRoute path='/termosdeuso' component={TermosDeUso} exact />
      <PublicRoute path='/contact' component={Contact} exact />
      <PrivateRoute path='/adoption' component={Landing} />
      <PrivateRoute path='/contact_inner' component={Landing} />
      <PrivateRoute path='/books' component={Landing} />
      <PrivateRoute path='/adoption_send' component={Landing} />
      <PrivateRoute path='/adoption_send_product' component={Landing} />
      <Route exact path='/admin' component={Admin} />
      <Route path='/privacy_policy.html' onEnter={reload} />
      <Route component={NotFound} />
    </Switch>
  </div>
)

export default Container



// WEBPACK FOOTER //
// ./src/routes/index.js